var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 3.53125C6.34375 3.17578 6.61719 2.875 7 2.875C7.35547 2.875 7.65625 3.17578 7.65625 3.53125V6.92188L9.98047 8.45312C10.2812 8.67188 10.3633 9.08203 10.1445 9.38281C9.95312 9.68359 9.54297 9.76562 9.24219 9.54688L6.61719 7.79688C6.45312 7.6875 6.34375 7.46875 6.34375 7.25V3.53125ZM7 0.25C10.8555 0.25 14 3.39453 14 7.25C14 11.1328 10.8555 14.25 7 14.25C3.11719 14.25 0 11.1328 0 7.25C0 3.39453 3.11719 0.25 7 0.25ZM1.3125 7.25C1.3125 10.3945 3.85547 12.9375 7 12.9375C10.1172 12.9375 12.6875 10.3945 12.6875 7.25C12.6875 4.13281 10.1172 1.5625 7 1.5625C3.85547 1.5625 1.3125 4.13281 1.3125 7.25Z",
    fill: "#A0438B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockActivity);
export default __webpack_public_path__ + "static/media/clock-activity.a0c932c7.svg";
export { ForwardRef as ReactComponent };